export const eulerSwapAddresses = {
  eulerSwapV1Factory: "0x0000000000000000000000000000000000000000",
  eulerSwapV1Implementation: "0x0000000000000000000000000000000000000000",
} as const
